export const colors = {
  primaryColor: '#740dc3',
  accentColor: '#8A02F2',
  backgroundColor: '#F0F0F0',
};

